export const queryKeys = {
  UNFINISHED_TESTS: 'unfinished-tests',
};
